<template>
  <div class="page-box" :style="{backgroundImage: `url(${imgBg})` }">
    <com-header />
    <div class="page-box-scroll">
      <div class="brand-list-details">
        <div class="brand-list-item" v-for="item in imgList" @click="jumpOpen(item.id)">
          <img :src="item.cover_image" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "threeClass",
  data(){
    return {
      imgList:[],
      imgBg:'',
      shopInfo: {}
    }
  },
  mounted(){
    this.shopInfo = JSON.parse(window.localStorage.getItem('shopInfo'))
    this.getCLassList({phototag_id: this.$route.query.id })
    this.getImgBg({id: this.$route.query.id })
  },
  methods:{
    getImgBg(params) {
      this.$get('/pc/shop/bgimg',params).then((res) => {
        this.imgBg = res.data.background_image
      }).catch((error) => {
      })
    },
    getCLassList(params) {
      this.$get('/pc/shop/threeClassify', params).then((res) => {
        this.imgList = res.data
      }).catch((error) => {
      })
    },
    jumpOpen(id) {
      this.$router.push(`imgDetails?id=${id}`)
    }
  }
}
</script>


<style scoped lang="less">
.page-box {
  height: 100vh;
  background-size: cover;
}
.brand-list-details {
  display: flex;
  flex-wrap: wrap;
  width: calc(100vw - 160px);
  margin: 40px 80px;
  box-sizing: border-box;
}
.brand-list-item{
  width:calc(25vw - 55px);
  height:12.45vw;
  margin:  0 20px 20px 0;
  box-sizing: border-box;
  border-radius: 4px;
  >img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

}
.brand-list-item:nth-child(4n){
  margin-right: 0;
}
.brand-list-item:hover{
  transform: scale(1.02);
  transition: all 0.3s;
}

</style>



// WEBPACK FOOTER //
// src/views/threeClass.vue